import clsx from "clsx";

const Checkbox = ({ label, name, register, validation, error, ...other }) => {
  return (
    <div className="form-group">
      <div
        className={clsx(
          "form-check align-items-center",
          !!validation?.required && "required",
          error && "invalid"
        )}
      >
        <input
          type="checkbox"
          id={`${name}_checkbox`}
          className="form-check-input"
          {...register(name, validation)}
          {...other}
        />

        <label htmlFor={`${name}_checkbox`} className="form-check-label">
          {label}
        </label>
      </div>

      {error && <div className="invalid-feedback mt-2">{error.message}</div>}
    </div>
  );
};

export default Checkbox;
